import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { GenFormBuilder } from "../../../providers/form";
import { Utilities } from "./../../../providers/utilities";

@Component({
  selector: "app-widgets-right-form",
  templateUrl: "widgets-right-form.html",
})
export class WidgetsRightFormComponent {

  @Input() public widgets: any[];
  @Input() public currentWidget: any;
  @Input() public defaultLanguage: string;
  @Input() public language: string;
  @Output() public languageChange = new EventEmitter();
  @Output() public createOrUpdateWidget = new EventEmitter();

  public form: FormGroup;
  public submitAttempt = false;

  constructor(
    private formGenerate: GenFormBuilder,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
  ) { }

  public ngOnInit() {
    this.form = this.formBuilder.group({});

    this.formGenerate.genInputString("id", this.form);
    this.formGenerate.genInputNumber("order", this.form, true, this.widgets.length);
    this.formGenerate.genInputLang("title", this.form, this.defaultLanguage);
    this.formGenerate.genInputString("type", this.form, true);
    this.formGenerate.genInputString("background", this.form);
    this.formGenerate.genInputString("data_widget", this.form);

    if (this.currentWidget) {
      this.form.patchValue(this.currentWidget);
    }
  }

  public selected(event) {
    this.languageChange.emit(event);
  }

  public onSubmit({ value, valid }) {
    this.submitAttempt = true;
    if (valid) {
      this.createOrUpdateWidget.emit(value);
    } else {
      this.utilities.consoleError("Form", this.form);
      this.utilities.setToast("Form widget contain errors", 3000, "top");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets-right/widgets-right-form/widgets-right-form.ts